module.exports = __webpack_public_path__ + "static/img/payment-cash.eda4098.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-cash.png
// module id = H/8V
// module chunks = 0